import { NameResourceItem } from "../NameResourceItem";
import { createFullClassResource } from "../../fullResource";

export class Brand extends NameResourceItem {}

export const brandResource = createFullClassResource("plm/brand/", Brand);
